<template>
  <div class="detail-content-wrapper">
    <div class="tab-content-wrapper competition-application-tab">
      <div class="block-header with-border">
        <h1>收到的申请</h1>
      </div>
      <div class="block-wrapper">
        <div v-for="item in apply" :key="item.id">
          <div class="list-item">
            <div class="list-item-content">
              <div class="list-item-info">
                <h3>{{item.apply_name}}</h3>
              </div>
            </div>
            <div class="list-item-ctr">
                <Button @click="rejectShow({team_id:item.team_id,uid:item.apply_uid})">拒绝</Button>
                <Button type="primary" @click="acceptShow({team_id:item.team_id,uid:item.apply_uid})">接受</Button>
            </div>
          </div>
        </div>

        <div class="empty-placeholder small" style="height: 20vh;" v-if="apply.length <= 0">
          <div>暂无收到的申请</div>
        </div>
      </div>
      <div class="block-header with-border">
        <h1>发出的申请</h1>
      </div>
      <div class="block-wrapper">
        <div v-for="item in send" :key="item.id">
          <div class="list-item">
            <div class="list-item-content">
              <div class="list-item-info">
                <h3>{{item.team_name}}</h3>
              </div>
            </div>
            <!-- <div class="list-item-ctr">
              <Button type="primary">撤销</Button>
            </div> -->
          </div>
        </div>
        <div class="empty-placeholder small" style="height: 20vh;" v-if="send.length <= 0">
          <div>暂无发出的申请</div>
        </div>
      </div>
    </div>

    <Modal
        :scrollable="true"
        v-model="rejectModal"
        title="是否拒绝加入队伍"
        @on-ok="reject">
        <p>是否拒绝此同学加入队伍</p>
    </Modal>
    <Modal
        :scrollable="true"
        v-model="acceptModal"
        title="是否同意加入队伍"
        @on-ok="accept">
        <p>是否同意此同学加入队伍</p>
    </Modal>
  </div>
</template>
<script>
  import {mapState,mapActions} from 'vuex'
  export default {
    name:"request",
    data(){
      return {
        currentinfo:{},
        acceptModal:false,
        rejectModal:false,
        compet_id:0,
      }
    },
    computed:{
      ...mapState({
          list:state=>state.team.team_msg_list
      }),
      apply:function(){
        let temp = [];
        this.list.body.forEach(item => {
          if(item.is_apply == true){
            temp.push(item);
          }
        });
        return temp;
      },
      send:function(){
        let temp = [];
        this.list.body.forEach(item => {
          if(item.is_apply == false){
            temp.push(item);
          }
        });
        return temp;
      }
    },
    methods:{
      ...mapActions({
        getTeamMsg:'team/getTeamMsg',
        acceptTeam:'team/acceptTeam',
        rejectTeam:'team/rejectTeam',
      }),
      getList(){
        let _this = this;
        _this.getTeamMsg({
          data:{
            compet_id:_this.compet_id
          }
        });
      },
      acceptShow(info){
        this.currentinfo = info;
        this.acceptModal = true;
      },
      // 同意加入队伍
      accept(){
        let _this = this;
        this.acceptTeam({
          data:{
            team_id:0,
            uid:0,
          },
          callback:res=>{
            _this.$Message.success("加入成功");
            _this.getList();
          }
        });
      },
      rejectShow(info){
        this.currentinfo = info;
        this.rejectModal = true;
      },
      // 拒绝加入队伍
      reject(){
        let _this = this;
        this.rejectTeam({
          data:{
            team_id:0,
            uid:0,
          },
          callback:res=>{
            _this.$Message.success("拒绝成功");
            _this.getList();
          }
        });
      }
    },
    mounted(){
      let _this = this;
      _this.compet_id = this.$route.params.id;
      if(_this.compet_id > 0){
          this.getList();
      }
    }
  }
</script>
<style>
.detail-content-wrapper {
    -ms-flex: 1;
    flex: 1;
    width: 100%;
}
.tab-content-wrapper {
    padding: 16px 24px 48px;
    min-height: 60vh;
}
.block-header {
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.block-header.with-border h1, .block-header.with-border h2 {
    border-left: 4px solid #06f;
    padding-left: 12px;
    font-size:1.3em;
}
.block-wrapper {
    margin-bottom: 24px;
}
.list-item {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    border-bottom: 1px solid #e8eaec;
    padding: 16px;
}
.list-item .list-item-ctr {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
}
.list-item .list-item-ctr {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    margin-left: 32px;
}
</style>